import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  formatFinishPosition,
  formatMultiplier,
  formatOdds,
  formatPercent,
} from './utils';

const DEFAULT_COLUMNS = [
  { key: 'horseNumber', label: '馬番', align: 'center', type: 'number' },
  { key: 'horseName', label: '馬名', type: 'name' },
  { key: 'odds', label: '現在オッズ', align: 'right', type: 'odds' },
  { key: 'baseOdds', label: '想定オッズ', align: 'right', type: 'odds' },
  { key: 'winRate', label: '勝率', align: 'right', type: 'percent' },
  { key: 'expectedValue', label: '回収率', align: 'right', type: 'multiplier' },
  { key: 'aiRank', label: 'AI評価', align: 'center', type: 'rank' },
  { key: 'jockeyName', label: '騎手', type: 'text' },
  { key: 'runningStyle', label: '脚質', align: 'center', type: 'text' },
  { key: 'abilityIndex', label: '能力指数', align: 'right', type: 'rounded' },
];

const resolveNameSubtext = (row) => {
  if (row.nameSubtext) return row.nameSubtext;
  return `着順 ${formatFinishPosition(row.finishPosition)}`;
};

const renderCellValue = (row, column) => {
  const value = row?.[column.key];

  switch (column.type) {
    case 'number':
      return <span className="race-detail-horse-number-chip">{value ?? '-'}</span>;
    case 'name':
      return (
        <Box>
          <Typography className="race-detail-table-name">{value || '-'}</Typography>
          <Typography className="race-detail-table-subtext">{resolveNameSubtext(row)}</Typography>
        </Box>
      );
    case 'odds':
      return formatOdds(value);
    case 'percent':
      return formatPercent(value, column.digits ?? 1);
    case 'multiplier':
      return formatMultiplier(value, column.digits ?? 2);
    case 'rank':
      return (
        <span className={`race-detail-rank-badge race-detail-rank-${String(value || 'd').toLowerCase()}`}>
          {value || '-'}
        </span>
      );
    case 'rounded':
      return value === null || value === undefined ? '-' : Math.round(value);
    case 'text':
    default:
      return value ?? '-';
  }
};

function HorseDataTable({
  horses,
  eyebrow = 'RUNNER MATRIX',
  title = '出走馬データ',
  columns = DEFAULT_COLUMNS,
}) {
  return (
    <Box className="race-detail-panel">
      <Typography className="race-detail-section-eyebrow">{eyebrow}</Typography>
      <Typography className="race-detail-section-title">{title}</Typography>

      <TableContainer className="race-detail-table-shell" sx={{ mt: 2.5 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.key} align={column.align || 'left'}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {horses.map((horse) => {
              const highlightClass = horse.rank <= 3 ? 'race-detail-table-row-highlight' : '';
              return (
                <TableRow key={`horse-row-${horse.horseNumber}`} className={highlightClass} hover>
                  {columns.map((column) => (
                    <TableCell key={`${horse.horseNumber}-${column.key}`} align={column.align || 'left'}>
                      {renderCellValue(horse, column)}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default HorseDataTable;
